import { HttpCase, HttpH1BForms } from "../Http";

export class VisaCareI140CaseAPI {

  public static i140formsCreate(input: any) {
    var url = "i140forms/createI140PetitionerDetails";
    var obj = JSON.stringify(input);
    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH1BForms.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
 
        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static i140formsUpdate(input: any) {
 
    var url = "i140forms/updateI140PetitionerDetails";
    var obj = JSON.stringify(input);
    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH1BForms.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static getI140formsDetails(input: any) {
    var url = "i140forms/getI140PetitionerDetailsByCaseIdAndQuestionType/" + input.input.caseId +"/"+input.input.questionType;
 
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpH1BForms.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
    
  }

 

  public static i140FormPdfSubmit(input: any) {
 
    var url = "/caseflow/submitI140PdfGeneration/" + input.input ;
     
  //  +"?companyId="+input.input.companyCode;

    if (input === "") {
      return { data: [] };
    }      
 
  
    const resultMethod =HttpCase.axios().post(url,{
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
 
          return res;
    }).catch((e: any) => {
      
      return e.response;
    });

    return resultMethod;
  }

}